import { render } from "./ResearchQuestionCard.vue?vue&type=template&id=6915a156&scoped=true"
import script from "./ResearchQuestionCard.vue?vue&type=script&lang=js"
export * from "./ResearchQuestionCard.vue?vue&type=script&lang=js"

import "./ResearchQuestionCard.vue?vue&type=style&index=0&id=6915a156&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6915a156"

export default script